<!-- 

    ---
    OPTION A
    - img, cover ()

    <img src="../assets/img/fallback/model_800x800.jpg" alt="">	

    -> cover (default)
    -> contain

    class="o-fit--cover"
    class="o-fit--contain"

    ---
    OPTION B
    - <picture...

    The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. 

    ---
    OPTION C
    - hotspot additional

    ...

-->

<template>
    <div class="fallback-container" v-if="visible">
        <slot>
            <h1>Fallback.vue</h1>
        </slot>
    </div>
</template>


<script>

    export default {
        name: "FallbackContainer",
        data: function ()
        {
            return {
                visible: window.BABYLON_FALLBACK,
            };
        }
    };

</script>


<style scoped lang="scss">

    @import "../assets/scss/functions";
    @import "../assets/scss/variables";
    @import "../assets/scss/mixins";

    .fallback-container {

        width: 100%;
        top: gridColumnsToRem(-6);
        bottom: gridColumnsToRem(-6);
        left: 0;
        position: absolute;

        .hotspot {

            position: absolute;
            background: rgba(orange, 0.5);
            //box-shadow: 0 0 0 0.5vh rgba(orange, 0.85);
            border: 4px solid rgba(orange, 0.85);
            border-radius: 50%;

            top: 50%;
            left: 50%;

            pointer-events: auto;

            width: 5rem;
            height: 5rem;
            margin-top: -2.5rem;
            margin-left: -2.5rem;

            cursor: pointer;
        }


        picture {
            display: block;
        }
        // default 
        img {
            display: block;
            object-fit: cover;
            width: 100%;
            height: 100%;
        }

    }


</style>